import { AfterViewInit, Component, OnInit, Pipe, PipeTransform } from '@angular/core'
import { AuthService } from '../services/auth.services'
import { DomSanitizer } from '@angular/platform-browser'

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
    constructor(private sanitized: DomSanitizer) {
    }

    transform(value) {
        return this.sanitized.bypassSecurityTrustHtml(value)
    }
}

@Component({
    selector: 'app-promotion',
    templateUrl: './promotion.component.html',
    styleUrls: ['./promotion.component.css'],
})
export class PromotionComponent implements OnInit, AfterViewInit {

    en = {}
    showEN = true
    video: HTMLVideoElement

    constructor(private auth: AuthService) {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        const myVideo = <HTMLVideoElement>document.getElementById('promotion_video')
        myVideo.muted = true
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }
}



// WEBPACK FOOTER //
// ./src/app/promotion/promotion.component.ts